import { Box, Paper, Typography } from '@mui/material';
import { HELP_CONTENT, type HelpPageKey } from './helpContent';

/** Renders one Yardım info page from bundled client-side content (see helpContent.tsx). */
export function StaticPage({ pageKey }: { pageKey: HelpPageKey }) {
  const page = HELP_CONTENT[pageKey];
  return (
    <Box sx={{ maxWidth: 900 }}>
      <Typography variant="h5" gutterBottom>
        {page.title}
      </Typography>
      <Paper variant="outlined" sx={{ p: 3 }}>
        {page.body}
      </Paper>
    </Box>
  );
}
